import { usePayrollInitiateService, usePayrollExecuteService } from './payrollServices';

const usePayrollService = (service: 'initiate' | 'execute') => {
  if (service === 'initiate') {
    return usePayrollInitiateService;
  } else {
    return usePayrollExecuteService;
  }
};

export { usePayrollService };
